import React, { createContext, useReducer, useContext} from 'react';

export const AccountContext = createContext(null);
export const AccountContextDispatch = createContext(null);

export function AccountProvider({children}){
    const [account, dispatch] = useReducer(accountReducer, {accountDetails: {}, tokens: 0, loggedIn: false, password: ""});
    return(
        <AccountContext.Provider value={account}>
            <AccountContextDispatch.Provider value={dispatch}>
                {children}
            </AccountContextDispatch.Provider>  
        </AccountContext.Provider>
    )

}

function accountReducer(account, action){
    switch (action.type) {
        case 'login':
            return {...account, accountDetails: action.signin, loggedIn: true, password: action.passSecret}
        case 'tokens':
            account.accountDetails.tokens = action.tokens;
            return {...account, tokens: action.tokens}
        case 'logout':
            return {...account, accountDetails: {}, tokens: 0, loggedIn: false}
        case 'generation':
            let amount = account.accountDetails.tokens - action.amount;
            console.log("Before: ",account.accountDetails.tokens, " After: ", amount);
            account.accountDetails.tokens = amount;
            return {...account, tokens: account.tokens - action.amount}                           
        default:
            return {account}
    }
}

export function useAccountContext() {
    return useContext(AccountContext);
}

export function useAccountContextDispatch() {
    return useContext(AccountContextDispatch);
}